var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnterpriseListIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0192 3.71972C14.0192 -2.2151 0 -0.158941 0 3.71972V8.3928C0 12.2715 3.13096 15.4024 7.00962 15.4024C10.8883 15.4024 14.0192 12.2715 14.0192 8.3928V3.71972Z",
    fill: "#47B2FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4873 4.20593L6.09059 8.44403L3.99894 6.42785L2.80371 7.57995L6.09059 10.7482L11.6826 5.35804L10.4873 4.20593Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnterpriseListIcon);
export default __webpack_public_path__ + "static/media/enterprise_list_icon.f0481a5a1008904f3a3617e1cad4cbd5.svg";
export { ForwardRef as ReactComponent };